import { FC } from 'react';
import {
  FieldsRow,
  FormTextField,
  FieldsSection,
  FormCheckbox,
} from '../../../../../../../shared/components/form';
import { useTranslation } from 'react-i18next';
import { Stack, Button, Typography, Alert, styled } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { IPopupWrapper } from '../../../../../../../shared/components/popup/components/popup.component.tsx';
import { bakery2bTabState } from '../../bakery2b.state.ts';
import { IFormData } from './clientDetails.popup.tsx';
import { useBeforeClosePopup } from '../../../../../../../shared/components/popup/hooks/useBeforeClosePopup.tsx';

export const Content: FC<IContent> = ({ field, stream }) => {
  const { t } = useTranslation();
  const {
    watch,
    formState: { isDirty, errors },
    handleSubmit,
  } = useFormContext<IFormData>();

  const onSubmit = (data: IFormData) => {
    bakery2bTabState.pub.saveRecord(data);
    stream.emit('close');
  };

  useBeforeClosePopup({
    stream,
    isDirty,
  });

  return (
    <form noValidate onSubmit={handleSubmit(onSubmit)}>
      {watch('isDeactivated') && (
        <FieldsRow>
          <Alert severity='warning' sx={{ width: '100%' }}>
            <b>{t('settings.deactivate_message')}</b>
            <br />
            {t('common.reason')}: {watch('whyDeactivated')}
          </Alert>
        </FieldsRow>
      )}
      <FieldsRow paddingTop='8px' sx={{ gap: 1 }}>
        <FormTextField label={t('common.email')} disabled name='email' />
        <FormTextField
          label={t('common.name')}
          name='name'
          error={Boolean(errors['name'])}
          helperText={errors['name'] ? t(String(errors['name'].message)) : ''}
          autoFocus={'name' === field}
        />
      </FieldsRow>
      <FieldsRow>
        <Stack
          sx={{
            width: '100%',
          }}
        >
          <FormTextField
            autoFocus={'note' === field}
            label={t('common.note')}
            name='note'
            width='100%'
            multiline
            minRows={3}
            maxRows={5}
            slotProps={{ htmlInput: { maxLength: 128 } }}
          />
          <Typography
            sx={{
              textAlign: 'right',
              mt: '2px',
              mr: '2px',
              fontSize: 14,
              color: 'text.secondary',
            }}
          >
            {t('settings.left_symbols')}: {128 - (watch('note')?.length || 0)}
          </Typography>
        </Stack>
      </FieldsRow>
      <FieldsSection titleBoxSx={{ pt: 0 }} title={t('common.rights')}>
        <Stack
          sx={{
            paddingLeft: 1,
          }}
        >
          <FormCheckbox name='orderAddNewItem' label={t('settings.add_new_articles')} />
          <FormCheckbox
            name='orderNoDelivery'
            label={t('settings.order_no_delivery_on_this_day')}
          />
          <FormCheckbox name='orderShowPrice' label={t('settings.order_show_price_total')} />
          <FormCheckbox name='standardOrderEdit' label={t('settings.standard_order_edit')} />
        </Stack>
      </FieldsSection>
      <Stack
        direction='row'
        sx={{
          justifyContent: 'flex-end',
          mt: watch('isDeactivated') ? 3 : 10,
        }}
      >
        <Button variant='contained' sx={{ minWidth: '125px' }} type='submit' disabled={!isDirty}>
          <SButtonText>{t('common.save')}</SButtonText>
        </Button>
      </Stack>
    </form>
  );
};

interface IContent {
  field: string;
  stream: IPopupWrapper['stream'];
}

const SButtonText = styled('span')({
  whiteSpace: 'nowrap',
});
